import React, { FC } from "react";
import { Col, Row, Space } from "antd";
import Title from "antd/lib/typography/Title";
import { useIntl } from "react-intl";
import {
  Resource_AppointmentStatus,
  useGetPortalUserAppointmentsQuery,
} from "../../src/generated/graphql";
import moment from "moment";
import { AppointmentCard } from "../appointment-card";
import Link from "next/link";
import styles from "./home.module.scss";

export const UpcomingAppointments: FC = () => {
  const { formatMessage } = useIntl();

  const { data: appointmentsData } = useGetPortalUserAppointmentsQuery({
    variables: {
      statusIn: [Resource_AppointmentStatus.AppointmentStatusBooked],
    },
  });

  const proxyAppointments =
    appointmentsData?.getPortalUserAppointments?.proxyAppointments
      ?.filter((proxyAppointment) => {
        const status = proxyAppointment?.appointment?.appointmentStatus;
        const startTime = proxyAppointment?.appointment?.startTime;

        return (
          status === Resource_AppointmentStatus.AppointmentStatusBooked &&
          startTime?.seconds > moment().unix()
        );
      })
      ?.sort(
        (a, b) =>
          a!.appointment!.startTime!.seconds! -
          b!.appointment!.startTime!.seconds!
      );

  return proxyAppointments && proxyAppointments?.length > 0 ? (
    <Space
      style={{ width: "100%" }}
      direction={"vertical"}
      size={8}
      className={styles.upcomingAppointments}
    >
      <Row>
        <Col lg={12} xs={24}>
          <Title level={2}>
            {formatMessage({ id: "upcoming-appointments" })}
          </Title>
        </Col>
        <Col lg={12} xs={0} style={{ textAlign: "right" }}>
          <Title level={3}>
            <Link href={"/appointments"}>
              {formatMessage({ id: "see-all" })}
            </Link>
          </Title>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        {proxyAppointments?.slice(0, 2)?.map((proxyAppointment) => (
          <Col lg={12} xs={24} key={proxyAppointment?.appointment?.id}>
            <AppointmentCard appointmentProxy={proxyAppointment} />
          </Col>
        ))}
      </Row>
    </Space>
  ) : null;
};
